import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FieldList from "components/common/FieldList";
import Header from "components/common/Header";
import useAlert from "hooks/useAlert";
import useToken from "hooks/useToken";
import withAuth from "hocs/withAuth";
import withPermission from "hocs/withPermission";
import dayjs from "dayjs";
import WarrantyServices from "services/taylormadeWarranty";

interface IWarrantyData {
  id: number;
  category: string;
  serialnumber: string;
  dealer: string;
  purchasedate: string;
  warrantyexpire: string;
  receiptUrl: string;
  createdat: string;
}
const EditWarrantyReport = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { token } = useToken();
  const { onAlert } = useAlert();

  const [warrantyData, setWarrantyData] = useState<IWarrantyData | null>(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    WarrantyServices.getDetailWarrantyReport(token as string, id as string)
      .then((res) => {
        setWarrantyData(res.data.data);
      })
      .catch((err) => {
        onAlert("error", err.response.data.message);
      });
  };

  const onSubmit = (data: any) => {
    let dataProps: IWarrantyData = data;

    WarrantyServices.editWarrantyReport(token as string, id as string, {
      ...dataProps,
    })
      .then((res) => {
        onAlert("success", "แก้ไข Warranty Report สำเร็จ");
        navigate("/taylormade/warranty-report");
      })
      .catch((err) => {
        onAlert("error", err.response.data.message);
      });
  };

  if (warrantyData) {
    return (
      <>
        <Header
          title="Edit Warranty Report"
          breadcrumbs={[
            {
              label: "Warranty Report",
              href: "/taylormade/warranty-report",
            },
            {
              label: "Edit",
            },
            {
              label: warrantyData?.serialnumber as string,
            },
          ]}
        />
        <FieldList
          type="edit"
          onSubmit={onSubmit}
          fields={[
            {
              label: "ID",
              type: "text",
              name: "id",
              col: 6,
              defaultValue: warrantyData?.id,
              disabled: true,
            },
            {
              label: "Category",
              type: "text",
              name: "category",
              col: 6,
              defaultValue: warrantyData?.category,
              disabled: true,
            },
            {
              label: "Serial Number",
              type: "text",
              name: "serialnumber",
              col: 6,
              defaultValue: warrantyData?.serialnumber,
              disabled: true,
            },
            {
              label: "Dealer",
              type: "text",
              name: "dealer",
              col: 6,
              defaultValue: warrantyData?.dealer,
              disabled: true,
            },
            {
              label: "Purchase Date",
              type: "date",
              name: "purchasedate",
              col: 6,
              defaultValue: warrantyData?.purchasedate,
              disabled: true,
            },
            {
              label: "Expire Date",
              type: "date",
              name: "warrantyexpire",
              inputOptions: {
                required: "กรุณากรอกวันหมดอายุ",
                minDate: dayjs(warrantyData.purchasedate),
              },
              col: 6,
              defaultValue: warrantyData?.warrantyexpire,
            },
          ]}
          onBack={() => navigate("/taylormade/warranty-report")}
        />
      </>
    );
  }
};

export default withAuth(
  withPermission(EditWarrantyReport, "MANAGE_TAYLORMADE_WARRANTY"),
);
